import { FETCH_ALL_REPORTS, FETCH_REPORT } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchReportsData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_REPORTS,
    message: `All reports data`,
    payload: fetchService(`${baseUrl.backend}/api/reports?page=${page}`),
  });

export const fetchReportData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_REPORT,
    message: `Report data`,
    payload: fetchService(`${baseUrl.backend}/api/reports/${id}`),
  });
